export const cardCompare = (a, b) => {
    // first by cardType: Indicator, Guage, Chart
    const getCardSortValue = (cardType: string) => {
        if (cardType === 'indicator') return 1;
        if (cardType === 'gauge') return 2;
        if (cardType === 'chart') return 3;
        else return 4;
    };

    const aCardSortValue = getCardSortValue(a.cardType);
    const bCardSortValue = getCardSortValue(b.cardType);
    if (aCardSortValue < bCardSortValue) return -1;
    else if (aCardSortValue > bCardSortValue) return 1;
    // then by name: alphabetically
    else if (a.name < b.name) return -1;
    else if (a.name > b.name) return 1;
    else return -1;
};
